import ArchiveFiltersManager from './ArchiveFiltersManager';
import MultiSelectCheckboxFilter from './MultiSelectCheckboxFilter';
import TickerAutocomplete from './TickerAutocomplete';

export function initFilters() {
  const archiveFiltersManager = new ArchiveFiltersManager();

  const tickerInput = document.querySelector('#ticker-autocomplete');
  const tickerChiclets = document.querySelector("#ticker-chiclets");
  const guidanceChiclets = document.querySelector("#guidance-chiclets");
  const guidanceFilter = document.querySelector("#guidance-filter");
  const serviceChiclets = document.querySelector("#service-chiclets");
  const serviceFilter = document.querySelector("#service-filter");

  new MultiSelectCheckboxFilter(
    guidanceFilter,
    archiveFiltersManager,
    guidanceChiclets
  );

  new MultiSelectCheckboxFilter(
    serviceFilter,
    archiveFiltersManager,
    serviceChiclets
  );

  if (tickerInput) {
    new TickerAutocomplete(tickerInput, archiveFiltersManager, tickerChiclets);
  }
}
